<template>
  <div class="popover-container">
    <ui-toast
      class="success-toast"
      icon-name="check_circle_icon"
      :open="isSuccessToastOpen"
      @close="changeStatusToast"
    >
      <template #content>Ссылка скопирована</template>
    </ui-toast>
    <ui-button
      variant="secondary"
      colorMode="neutral"
      iconName="share_icon"
      text="Поделиться"
      @clicked="changeStatusPopover"
    />
    <ui-popover
      v-if="!isMobile"
      :open="isOpenPopover"
      @close="changeStatusPopover"
    >
      <template #content>
        <Share @copy="copy" />
      </template>
    </ui-popover>

    <ui-modal
      v-else
      is-footer-hidden
      :is-shown="isOpenPopover"
      title="Поделиться"
      @close="changeStatusPopover"
    >
      <template #content>
        <Share @copy="copy" />
      </template>
    </ui-modal>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { UiButton, UiPopover, UiToast } from '@experience/vue3-kit';
  import { UiModal } from '@experience/core-modal-ui';
  import Share from './Share.vue';
  import { useScreenSize } from '@/shared/utils/breakpoints';

  const isOpenPopover = ref(false);
  const isSuccessToastOpen = ref(false);

  const changeStatusPopover = () => {
    isOpenPopover.value = !isOpenPopover.value;
  };

  const changeStatusToast = () => {
    isSuccessToastOpen.value = !isSuccessToastOpen.value;
  };

  const copy = () => {
    changeStatusPopover();
    changeStatusToast();
  };

  const { isMobile } = useScreenSize();
</script>

<style lang="scss" scoped>
  .popover-container {
    position: relative;
  }

  .popover-content {
    display: flex;
    flex-direction: column;
  }

  .popover-content-item {
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 12px 0;
    cursor: pointer;

    @include base-400-400-regular;
  }

  :deep(.popover) {
    z-index: 5 !important;
    padding: 16px !important;
  }
</style>
